import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { ColorPicker, StarButton, TransparentVideo } from "~components";
import cn from "classnames";
import { useProductContext } from "~hooks";
import * as styles from "./styles.module.scss";

const ProductCard = ({ productId }) => {
  const { getProductData, getProductVariantsData } = useProductContext();
  const {
    pdpUrl,
    productVideo,
    productPageImages,
    productCardHoverImage,
    title,
    productImageBackgroundColor,
    comingSoon
  } = getProductData(productId) || {};

  const variantsData = getProductVariantsData(productId);

  const { price } = variantsData?.[0] || {};

  const hasProductVideo = productVideo?.webM && productVideo?.mov;

  return (
    <Link to={pdpUrl || ``} className={styles.container}>
      <div
        className={styles.defaultImage}
        style={{ backgroundColor: productImageBackgroundColor }}
      >
        {hasProductVideo && (
          <TransparentVideo webM={productVideo?.webM} mov={productVideo?.mov} />
        )}

        {!hasProductVideo && productPageImages?.[0] && (
          <GatsbyImage
            image={productPageImages?.[0].asset.gatsbyImageData}
            style={{
              position: `absolute`,
              inset: 0,
              border: `1px solid var(--color-black)`,
              borderRadius: `10px`
            }}
            alt={title || ``}
          />
        )}
      </div>
      <div className={styles.hoverImage}>
        {productCardHoverImage && (
          <GatsbyImage
            image={productCardHoverImage.gatsbyImageData}
            alt={productCardHoverImage.altText || ``}
            style={{ width: `100%`, height: `100%` }}
          />
        )}
      </div>
      <div className={styles.content}>
        <div>
          <div className={cn(`h4`, styles.title)}>{title || `TKTK`}</div>
          <div className={styles.price}>
            <span className="b1">
              ${price?.amount || `TKTK`}
              {` `}
            </span>
            <span className="caption">{price?.currencyCode || `AUD`}</span>
          </div>
        </div>

        {!comingSoon && (
          <ColorPicker
            display
            vertical
            variants={variantsData}
            itemClassName={styles.color}
          />
        )}
      </div>

      {comingSoon && (
        <div className={styles.comingSoonContainer}>
          <StarButton display className={styles.comingSoon}>
            Coming soon
          </StarButton>
        </div>
      )}
    </Link>
  );
};

export default ProductCard;
